import { NotificationManager } from "react-notifications";
import { api } from "api";
import { handleActions } from 'redux-actions';
import { listadoDeIngresos } from "../informes";
import Swal from 'sweetalert2';

const PARAMETRO = 'PARAMETRO';
const LOADER = 'LOADER';
const LINEAS_POLIZA = 'LINEAS_POLIZA';

const setLoader = loader => ({
    type: LOADER,
    loader,
});


export const listarVentas = () => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id }
    return api.get('auto_ventas/ventas', params).then(response => {
        return response;
    }).catch((error) => {
        return [];
    })
}

export const listarVendedores = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id, search }
    return api.get('auto_ventas/vendedores/listado_resumido', params).then(response => {
        let vendedoresList = []
        response.forEach(item => {
            vendedoresList.push({
                    value: item.vendedor.id,
                    label: item.vendedor.value 
                })
            }
        )
        return vendedoresList;
    }).catch((error) => {
        return [];
    })
}

export const datosDelIngreso = (ingresoId) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let action = "ver"
    const params = { id, action }
    return api.get(`auto_ventas/ingresos/${ingresoId}`, params).then(response => {
        return response;
    }).catch((error) => {
        NotificationManager.error(
            "Ocurrio un error al obtener los datos",
            'Error',
            2000,
            null,
            true
        );
        return [];
    })
}

export const crearVenta = (data) => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    if (data.datos.contabilidad === 'S'){
        const totalDebe = data.lineasPoliza.reduce((sum, linea) => sum + linea.debe, 0);
        const totalHaber = data.lineasPoliza.reduce((sum, linea) => sum + linea.haber, 0);

        if (data.lineasPoliza.length === 0) {
            Swal.fire({
                title: 'Ventas',
                text: 'Debe agregar líneas a la póliza',
                type: 'error',
            });
            return;
        }else if (Math.abs(totalDebe - totalHaber) >= 0.01) {
            Swal.fire({
                title: 'Ventas',
                text: 'Póliza con diferencia',
                type: 'error',
            });
            return;
        }else{
            if (data.periodo === undefined || data.periodo === ''){
                Swal.fire({
                    title: 'Ventas',
                    text: 'Debe de seleccionar periodo',
                    type: 'error',
                })
            }else{
                let fecha = getFechasDePeriodo(data.periodo.label, data.fecha_poliza);
                if (fecha === false){
                    Swal.fire({
                        title: 'Ventas',
                        text: 'Fecha fuera del periodo seleccionado',
                        type: 'error',
                    });
                    return;
                }else{
                    data.empresa = id 
                    data.contabilidad = data.datos.contabilidad
                    data.periodo = data.periodo.value
                    data.carro = data.carro.value
                    data.vendedor = data.vendedor.value
                    const params = { id, data }
                    dispatch(setLoader(true));
                    return api.post('auto_ventas/ventas', params).then((response) => {
                        NotificationManager.success(
                            'Venta agregada',
                            'Exito',
                            3000,
                            null,
                            true
                        );
                        return response;
                    }).catch((error) => {
                        NotificationManager.error(
                            error.msj,
                            'Error',
                            2000,
                            null,
                            true
                        );
                        return false;
                    }).finally(() => {
                        dispatch(setLoader(false));
                    });
                }
            }
        }
    }else{
        data.empresa = id 
        data.carro = data.carro.value
        data.vendedor = data.vendedor.value
        const params = { id, data }
        dispatch(setLoader(true));
        return api.post('auto_ventas/ventas', params).then((response) => {
            NotificationManager.success(
                'Venta agregada',
                'Exito',
                3000,
                null,
                true
            );
            return response;
        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                2000,
                null,
                true
            );
            return false;
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }
}

export const reporteVentaDeVehiculos = (ventaId) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    // let carroId = data.marca.value
    let rep = 'venta_de_vehiculos';
    const params = { id, rep, ventaId };
    api.getPdf('/auto_ventas/ventas/reportes', params).then((response)=>{
        if (response.headers['content-type'] == 'application/pdf'){
            var blob = new Blob([response.text], { type: 'application/pdf;charset=utf-8' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'recepcion_de_vehiculos.pdf';
            window.open(link, '_blank');
            return false;
          }
    }).catch((error)=>{
        if (error.status === 404){
            NotificationManager.info(
              error.body.msj,
              'Informacion',
              5000
            );
        }
        if (error.status === 500){
            NotificationManager.error(
              'Ocurrió un error al generar reporte',
              'Error',
              2000
            );
        }
    })
}

export const listarPeriodos = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id, search }
    return api.get('/periodos/periodo_empresa', params).then(response => {
        let periodosList = []
        response.forEach(item => {
            periodosList.push({
                    value: item.id,
                    label: item.periodo 
                })
            }
        )
        return periodosList;
    }).catch((error) => {
        return [];
    })
}

export const listarCuentas = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/cuentas/empresa_cuentas/',params).then(data=>{
        const list_cuentas = [];
        if(data){
            data.forEach(item=>{
                if (item.tipo === 'A'){
                    list_cuentas.push({
                        value: item.id,
                        label: item.cuenta + ' ' + item.nombre,
                        isDisabled: true
                    })
                }else{
                    list_cuentas.push({
                        value: item.id,
                        label: item.cuenta + ' ' + item.nombre
                    })
                }
            })
        }
        return list_cuentas;
    }).catch((error)=>{
        return [];
    })
}

export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id}
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({type: PARAMETRO, datos: response });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    })
}

function getFechasDePeriodo(periodoNombre, fecha_poliza_str) {
    const [mes, anio] = periodoNombre.split(' ');
    const fecha_poliza = new Date(fecha_poliza_str);
    const meses = {
        'ENERO': 0, 'FEBRERO': 1, 'MARZO': 2, 'ABRIL': 3, 'MAYO': 4, 'JUNIO': 5,
        'JULIO': 6, 'AGOSTO': 7, 'SEPTIEMBRE': 8, 'OCTUBRE': 9, 'NOVIEMBRE': 10, 'DICIEMBRE': 11
    };
    
    const mesNum = meses[mes];
    const fechaInicio = new Date(parseInt(anio), mesNum, 1);
    
    // Último día del mes
    const fechaFin = new Date(parseInt(anio), mesNum + 1, 0);

    if (fecha_poliza >= fechaInicio && fecha_poliza <= fechaFin){
        return true
    }else{
        return false
    }
}


let datoPoliza = []
export const agregarLineaPoliza = (data) => (dispatch) => {
    if (!data.cuenta) {
        Swal.fire({
            title: 'Ventas',
            text: 'Debe seleccionar una cuenta',
            type: 'error',
        })
    }else{
        if (data.periodo === undefined || data.periodo === ''){
            Swal.fire({
                title: 'Ventas',
                text: 'Debe de seleccionar periodo',
                type: 'error',
            })
        }else{
            let fecha = getFechasDePeriodo(data.periodo.label, data.fecha_poliza);
            if (fecha === false){
                Swal.fire({
                    title: 'Ventas',
                    text: 'Fecha fuera del periodo seleccionado',
                    type: 'error',
                });
                return;
            }else{
                if ((parseFloat(data.debe) || 0) === 0 && (parseFloat(data.haber) || 0) === 0) {
                    Swal.fire({
                        title: 'Ventas',
                        text: 'Debe ingresar un valor en debe o haber',
                        type: 'error',
                    })
                }else{
                    if ((parseFloat(data.debe) || 0) !== 0 && (parseFloat(data.haber) || 0) !== 0) {
                        Swal.fire({
                            title: 'Ventas',
                            text: 'Solo debe ingresar un valor en debe o haber, no ambos',
                            type: 'error',
                        });
                        return;
                    }else{
                        datoPoliza.push({
                            id: Date.now(),
                            cuenta: (data.cuenta && data.cuenta.label) || "",
                            cuenta_id: (data.cuenta && data.cuenta.value) || null,
                            debe: parseFloat(data.debe) || 0,
                            haber: parseFloat(data.haber) || 0
                        });
                        dispatch({type: LINEAS_POLIZA, lineasPoliza: [...datoPoliza] });
                    }
                }
            }
        }
    }
}

const limpiar = () => (dispatch) => {
    datoPoliza = [];
    dispatch({ type: LINEAS_POLIZA, lineasPoliza: [] });
};


export const eliminarLinea = (id) => (dispatch) => {
    Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Está seguro que desea eliminar esta línea de la póliza?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.value) {
            datoPoliza = datoPoliza.filter(linea => linea.id !== id);
            dispatch({ type: LINEAS_POLIZA, lineasPoliza: [...datoPoliza] });

            Swal.fire({
                title: 'Eliminado',
                text: 'La línea ha sido eliminada correctamente',
                type: 'success',
                timer: 1500,
                showConfirmButton: false
            });
        }
    });
};


export const actions = {
    crearVenta,
    datosDelIngreso,
    listarVendedores,
    listadoDeIngresos,
    listarVentas,
    reporteVentaDeVehiculos,
    listarPeriodos,
    listarCuentas,
    parametrosEmpresa,
    agregarLineaPoliza,
    eliminarLinea,
    limpiar
};

export const reducers = {
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LINEAS_POLIZA]: (state, { lineasPoliza }) => {
        return {
            ...state,
            lineasPoliza,
        };
    },
}

export const initialState = {
    datos: [],
    loader: false,
    lineasPoliza: [],
};

export default handleActions(reducers, initialState)